import Utils from '@/common/utils/utils';
import { TextField } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React from 'react';
import { validateInvidualInputs } from '../EditOrganizationHandler';

export default function CorporationInvidualBasicSetting({
    listInvidualBasic,
    setListInvidualBasic,
    setIsEdit,
    corpActiveIsBlock
}) {
    const setValInvidualBasic = (val, index, eventBlur = false, label = '') => {
        const cloneListInvidual = [...listInvidualBasic];
        const item = cloneListInvidual[index];
        item.value = val;
        if (eventBlur) {
            item.error = validateInvidualInputs(val, label);
        }

        return cloneListInvidual;
    }

    const handleOnChangeInput = (e, index) => {
        const val = e.target.value;
        setListInvidualBasic(setValInvidualBasic(val, index));
        setIsEdit(true);
    };

    const handleOnBlurInput = (e, index, label) => {
        let val = e.target.value;
        
        setListInvidualBasic(setValInvidualBasic(val, index, true, label));
    }

    if (Utils.isEmptyArray(listInvidualBasic)) return null;
    return (
        <>
            <p className="desc-invidual-guidline">
                バージョンで設定されている値にここで設定した値がプラスされます。
            </p>
            {listInvidualBasic?.map((invidual, index) => {
                return (
                    <>
                        <div className="item-invidual" key={index}>
                            <div className="label">{I18n.get(invidual.label)}</div>
                            <div>
                                <TextField
                                    className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                                    variant="outlined"
                                    disabled={invidual?.disabled || corpActiveIsBlock}
                                    value={invidual?.value}
                                    onChange={e => handleOnChangeInput(e, index)}
                                    onBlur={e => handleOnBlurInput(e, index, invidual.label)}
                                    helperText={invidual?.error}
                                    error={
                                        !Utils.isEmptyString(invidual?.error)
                                    }
                                />
                                <span>{invidual.unit}</span>
                            </div>
                        </div>
                    </>
                );
            })}
        </>
    );
}
